import React from "react";

function SearchSvgBlog() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        stroke="#6B7280"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M14.75 14.75l-4.5-4.5m1.5-3.75a5.25 5.25 0 11-10.501 0 5.25 5.25 0 0110.501 0z"
      ></path>
    </svg>
  );
}

export default SearchSvgBlog;
